module.exports = __webpack_public_path__ + "img/20191128170831343.8ad0ebea.jpg";